import { ApplicationMuiTheme } from 'Lib/themes/muiTheme';

export const muiStyles = (theme: ApplicationMuiTheme) => ({
    container: {
        height: '100%',
        background: theme?.app?.applicationColors.backgroundPrimary ||
            '#FFFFFF'
    },
    header: {
        flexBasis: 'auto',
        flexShrink: 1
    },
    accountSelectContainer: {
        width: '100%',
        padding: '1.9rem 0',
        paddingLeft: '2rem'
    },
    accountSelect: {
        '& div': {
            color: '#000',
            whiteSpace: 'pre-line',
            'line-height': '16px'
        }
    },
    accountSelectDisabled: {
        '& div:nth-child(2)': { visibility: 'hidden' },
        '& div': { border: 'none' }
    },
    selectNoOptions: { 'text-align': 'left' },
    rowStyle: {
        marginLeft: '12px',
        marginRight: '12px',
        boxSizing: 'border-box' as const,
        background: 'white'
    },
    cellStyle: { padding: '.5rem' },
    notification: {
        background: theme?.app?.applicationColors.success ||
            '#A5D673',
        width: '100%',
        padding: '.5rem 1rem',
        color: '#FFF'
    },
    notificationError: {
        background: theme?.app?.applicationColors.failure ||
            '#FA5252',
        width: '100%',
        padding: '.5rem 1rem',
        color: '#FFF'
    }
});